<template>
    <div class="loginCon">
      <div class="one" :class="{active:isShow}">
        <img class="animated fadeInUp" src="../assets/logo.png" alt="">
      </div>
      <span v-if="!isShow"></span >
      <div class="three" :class="{activeT:isShow}">
        <p>{{num}}%</p>
      </div>

    </div>
</template>

<script>
    export default {
        name: "login",
      data(){
          return{
            num:0,
            se:0,
            isShow:false,
          }
      },
      mounted(){
          let time=setInterval(()=>{
            this.num++
            this.se++
            if(this.num==100){
              this.isShow=true
              clearInterval(time)
            }
          },30)
        setTimeout(()=>{
          this.$router.push({path:'/home'})
        },4000)
      }
    }
</script>

<style lang="scss" scoped>
.loginCon{
  width:100%;
  height:100vh;
  overflow: hidden;
  .one{
    width:100%;
    height:48%;
    position: relative;
    img{
      position: absolute;
      bottom: 0;
      left: 42%;
    }
  }
  span{
    display: inline-block;
    width:100%;
    height:1px;
    background-color: rgba(99, 99, 99, 1);
    animation-name:mymove;
    animation-duration:3s;
    /*Safari 和 Chrome*/
    -webkit-animation:mymove 3s ;
    animation-fill-mode: forwards;
  }
  @keyframes myMove {
    from {width:0;}
    to {width:100%;}
  }
  @-webkit-keyframes mymove /*Safari 和 Chrome*/{
    from {width:0;}
    to {width:100%;}
  }
  .three{
    width:100%;
    height:48%;
  }
  p{
    text-align: center;
    color:#0C3665;
  }
  .active{
    transition: 1s;
    transform: translateY(-100%);
  }
  .activeT{
    transition: 1s;
    transform: translateY(110%);
  }
  @media screen and (min-width:2000px){
 .one{
   img{
     left: 45%;
   }
 }
  }
  @media screen and (max-width:1366px){
    .one{
      img{
        left: 40%;
      }
    }
  }
  @media screen and (max-width:768px){
    .one{
      img{
        left: 32%;
      }
    }
  }
  @media screen and (max-width:450px){
    .one{
      img{
        left: 15%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue